/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/dailyStatistics";

// RIS migration: a non-integer partnerId is a RIS proCompanyId (base64 GUID). Backend accepts
// either `partnerId=<int>` (legacy TT path) or `proCompanyId=<encoded>` (pro path, queries
// DailyStatistics.ProPartnerAccountId directly).
const isProPartnerId = (partnerId) =>
    partnerId !== null && partnerId !== undefined && partnerId !== "" && isNaN(Number(partnerId));

class DailyStatisticsService {
    
    partnerEnergySummary(partnerId) {
        if (isProPartnerId(partnerId)) {
            return http.get(`${controller}/partnerEnergySummary?proCompanyId=${encodeURIComponent(partnerId)}`);
        }
        return http.get(`${controller}/partnerEnergySummary?partnerId=${partnerId}`);
    }

    monthlypartnerdata(month, year, partnerId) {
        if (isProPartnerId(partnerId)) {
            return http.get(`${controller}/monthlypartnerdata?month=${month}&year=${year}&proCompanyId=${encodeURIComponent(partnerId)}`);
        }
        return http.get(`${controller}/monthlypartnerdata?month=${month}&year=${year}&partnerId=${partnerId}`);
    }

    monthlyAssetData(month, year, assetIds) {
        let query = assetIds.join('&assetIds=');
        const response = http.get(`${controller}/monthlyassetdata?month=${month}&year=${year}&assetIds=${query}`);
        return response;
    }

    getruncounts() {
        const response = http.get(`${controller}/getruncounts`);
        return response;
    }
}

export default new DailyStatisticsService();